import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldPasswordVerifyComponent } from './field-password-verify.component';
import { CardComponent } from '../../../@theme/components/card/card.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';



@NgModule({
  declarations: [
    FieldPasswordVerifyComponent,
  ],
  exports: [
    FieldPasswordVerifyComponent
  ],
  imports: [
    CommonModule,
    CardComponent,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule
  ]
})
export class FieldPasswordVerifyModule { }
